module.exports = __webpack_public_path__ + "53e484313638fe90c6097c099aaeb712.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/deloitte_2023_chart.png
// module id = 1661
// module chunks = 0